import { createSlice } from "@reduxjs/toolkit";


export const sessionSlice = createSlice({
  name: "session",
  initialState: {
    id: localStorage.getItem("UKUA-session-id") || btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(15)))).replace(/[/]/g, '_').replace(/[+]/g, '-'),
    showsessionPrompt: false,
    cookiePopup: true,
  },
  reducers: {
    cookiesOK: (slice) => {
        localStorage.setItem('UKUA-session-id', slice.sessionId)
    },
  },
});

export const showsessionPrompt = (state) => state.session.showsessionPrompt;
export const getSessionId = (state) => state.session.id;
export const {requestsession} = sessionSlice.actions;
